import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/backend/api-client";

/**
 * Check if the current user is a Liquidity Provider
 * Returns true if user has an active LP account
 * 
 * INDUSTRY STANDARD: Uses dedicated status endpoint that always returns 200 OK
 * This prevents 404 errors from leaking system architecture information
 */
export function useLPStatus(userId: string | null) {
  return useQuery({
    queryKey: ["lp-status", userId],
    queryFn: async () => {
      if (!userId) return { isLP: false };
      
      try {
        // Use dedicated status endpoint (always returns 200 OK)
        const response = await apiClient.get(`/api/lp/status?user_id=${userId}`);
        const data = response as any;
        return {
          isLP: data?.has_lp_account && data.status === "active",
        };
      } catch (_error) {
        // Fallback to false on any error
        return { isLP: false };
      }
    },
    enabled: !!userId,
    staleTime: 300000, // Cache for 5 minutes (reduced polling)
    retry: false, // Don't retry on error
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch on component remount if cached
  });
}

